const playerErrors = {
  CATEGORY_NOT_FOUND: 'No es posible cargar el contenido por el momento, intente mas tarde.',
  MEDIA_INVALID_ID: 'No es posible reproducir el titulo.',
  NOT_FOUND: 'No es posible encontrar temporadas para esta serie.',
  NOT_FOUND_NEXT_EPISODE: 'No es posible encontrar siguientes episodios para esta serie.'
};

export default playerErrors;
